import { useEffect, useState } from 'react';

/**
 * Returns `false` initially, then flips to `true` after `delayMs`. Used to
 * defer mounting the composer so the host page can paint before
 * framer-motion + LayoutGroup setup kicks in.
 */
export const useDeferredFlag = (delayMs: number): boolean => {
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        const timerId = window.setTimeout(() => setIsReady(true), delayMs);

        return () => window.clearTimeout(timerId);
    }, [delayMs]);

    return isReady;
};
